import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './Footer.module.scss'
import Facebook from './assets/Facebook_32.svg'
import Twitter from './assets/Twitter_32.svg'
import LinkedIn from './assets/LinkedIn_32.svg'
import Youtube from './assets/Youtube_32.svg'
import Logo from '../../assets/logo.svg'
import LanguagePicker from '../language-picker/LanguagePicker'

const Footer: React.FC = () => {
  const t = useIntl()
  const locale = t.locale
  return (
    <footer className={styles.cgFooterHuge}>
      <div className={styles.logo}>
        <Logo className={styles.svg} />
        <p className={styles.copyright}>
          {t.formatMessage({ id: 'cgFooterHuge.copyright' }, { year: process.env.GATSBY_YEAR })}
        </p>
        <LanguagePicker />
      </div>

      <div className={styles.company}>
        <h3>
          {t.formatMessage({ id: 'cgFooterHuge.company.title' })}

        </h3>
        <a href='/about'>
          {t.formatMessage({ id: 'cgFooterHuge.company.aboutUs' })}
        </a>
        <a href='/careers'>
          {t.formatMessage({ id: 'cgFooterHuge.company.careers' })}
        </a>
        <a target='_blank' href='/blog/'>
          {t.formatMessage({ id: 'cgFooterHuge.company.blog' })}
        </a>
        <a target='_blank' href={locale === 'fr' ? '/work/fr/press/' : '/work/press/'} rel='noreferrer'>
          {t.formatMessage({ id: 'cgFooterHuge.company.press' })}
        </a>
        <a href='/legal/privacy-policy'>
          {t.formatMessage({ id: 'cgFooterHuge.company.legalNotice' })}
        </a>
      </div>

      <div className={styles.developers}>
        <h3>
          {t.formatMessage({ id: 'cgFooterHuge.developers.title' })}
        </h3>
        <a href='/training'>
          {t.formatMessage({ id: 'cgFooterHuge.developers.practice' })}
        </a>
        <a href='/multiplayer'>
          {t.formatMessage({ id: 'cgFooterHuge.developers.compete' })}
        </a>
        <a href='/escape'>
          {t.formatMessage({ id: 'cgFooterHuge.developers.cooperate' })}
        </a>
        <a href='/learn'>
          {t.formatMessage({ id: 'cgFooterHuge.developers.learn' })}
        </a>
        <a href='/faq'>
          {t.formatMessage({ id: 'cgFooterHuge.developers.faq' })}
        </a>
        <a href='/rules'>
          {t.formatMessage({ id: 'cgFooterHuge.developers.rules' })}
        </a>
      </div>

      <div className={styles.employers}>
        <h3>
          {t.formatMessage({ id: 'cgFooterHuge.employers.title' })}
        </h3>
        <a href='/work' target='_blank' rel='noopener'>
          {t.formatMessage({ id: 'cgFooterHuge.employers.overview' })}
        </a>
        <a href='/work/offers/screening' target='_blank' rel='noopener'>
          {t.formatMessage({ id: 'cgFooterHuge.employers.assessments' })}
        </a>
        <a href='/work/offers/interviewing' target='_blank' rel='noopener'>
          {t.formatMessage({ id: 'cgFooterHuge.employers.interviewing' })}
        </a>

      </div>

      <div className={styles.socialNetworks}>
        <a
          className={styles.socialNetwork}
          href='https://www.facebook.com/CodinGame'
          target='_blank'
          rel='noopener noreferrer'
        >
          <Facebook className={styles.socialNetworkIcon} />
        </a>
        <a
          className={styles.socialNetwork}
          href='https://twitter.com/codingame'
          target='_blank'
          rel='noopener noreferrer'
        >
          <Twitter className={styles.socialNetworkIcon} />
        </a>
        <a
          className={styles.socialNetwork}
          href='https://fr.linkedin.com/company/codingame'
          target='_blank'
          rel='noopener noreferrer'
        >
          <LinkedIn className={styles.socialNetworkIcon} />
        </a>
        <a
          className={styles.socialNetwork}
          href='https://www.youtube.com/channel/UCJ6woCHjGCBXqpf91SsAcoQ'
          target='_blank'
          rel='noopener noreferrer'
        >
          <Youtube className={styles.socialNetworkIcon} />
        </a>
      </div>
    </footer>
  )
}

export default Footer
